import React from "react";

export default function EftalLogo({
  width = 177,
  height = 55,
  className = "",
  ...props
}) {
  return (
    <svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 177.27 55.09"
      width={width}
      height={height}
      className={className}
      {...props}
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <g>
          <g>
            <path
              fill="#2d2a32"
              d="M15.14,50.17h-3.44v4.75h-1.01v-12.74h3.98c2.37,0,4.19,1.8,4.19,3.98,0,1.68-1.12,3.23-2.79,3.74l2.86,5.03h-1.13l-2.65-4.75ZM11.7,43.1v6.14h2.88c1.94,0,3.26-1.5,3.26-3.09,0-1.73-1.33-3.05-3.25-3.05h-2.9Z"
            />
            <path
              fill="#2d2a32"
              d="M28.08,42.17h7.8v.96h-6.79v4.92h6.79v.94h-6.79v4.96h6.79v.96h-7.8v-12.74Z"
            />
            <path
              fill="#2d2a32"
              d="M45.24,42.17h1.12l8.2,11.17v-11.17h1.01v12.74h-1.08l-8.24-11.22v11.22h-1.01v-12.74Z"
            />
            <path
              fill="#2d2a32"
              d="M68.7,43.1h-3.98v-.93h8.97v.93h-3.98v11.82h-1.01v-11.82Z"
            />
            <path
              fill="#2d2a32"
              d="M98.49,42.17h1.08l4.91,12.74h-1.06l-1.38-3.56h-6.02l-1.36,3.56h-1.07l4.91-12.74ZM96.37,50.4h5.29l-2.64-6.88-2.65,6.88Z"
            />
            <path
              fill="#2d2a32"
              d="M124.46,48.55c0-3.61,2.93-6.55,6.55-6.55,2.39,0,4.45,1.31,5.62,3.21l-.87.51c-.96-1.66-2.65-2.78-4.75-2.78-3.11,0-5.52,2.53-5.52,5.6s2.41,5.59,5.52,5.59c2.29,0,4-1.19,4.91-2.93l.89.45c-1.12,2.06-3.21,3.44-5.8,3.44-3.61,0-6.55-2.93-6.55-6.55Z"
            />
            <path
              fill="#2d2a32"
              d="M149.79,42.17h1.08l4.91,12.74h-1.06l-1.38-3.56h-6.02l-1.36,3.56h-1.07l4.91-12.74ZM147.68,50.4h5.29l-2.64-6.88-2.65,6.88Z"
            />
            <path
              fill="#2d2a32"
              d="M169.18,50.17h-3.44v4.75h-1.01v-12.74h3.98c2.37,0,4.19,1.8,4.19,3.98,0,1.68-1.12,3.23-2.79,3.74l2.86,5.03h-1.13l-2.65-4.75ZM165.74,43.1v6.14h2.88c1.94,0,3.26-1.5,3.26-3.09,0-1.73-1.33-3.05-3.25-3.05h-2.9Z"
            />
          </g>

          <g>
            <path
              fill="#2d2a32"
              d="M45.93,0l-1.91,7.98H13.86s-.08,0-.1.03L15.8,0h30.13Z"
            />
            <path
              fill="#2d2a32"
              d="M39.43,26.89c-.58,2.42-1.21,5.06-1.91,7.96h-20.47c-2.47,0-4.41-.91-5.89-2.72-1.51-1.79-1.99-3.88-1.49-6.22l1.91-7.88h3.33c.43,0,.81-.3.93-.71l1.01-3.9h18.43l-1.84,7.98h-14.15l-1.03,4.23c-.05.33.03.63.23.86.18.25.45.38.78.38l20.17.03Z"
            />
            <path
              fill="#2d2a32"
              d="M56.35,8.21c.2-.15.4-.23.58-.23l20.62-.03,1.96-7.96h-23.87c-3.57,0-6.07,1.91-7.5,5.77l-7.02,29.08h8.48l3.25-13.44h14.07l1.86-7.98h-14l1.11-4.58c.1-.25.25-.48.45-.63Z"
            />
            <path
              fill="#2d2a32"
              d="M83.59,0l-1.94,7.93h11.51l-6.82,26.91h8.23l6.72-26.91h11.15l1.96-7.93h-30.82Z"
            />
            <path
              fill="#2d2a32"
              d="M124.27,0c-3.42,0-5.82,1.91-7.18,5.77l-7.1,29.08h8.18l2.32-9.59h12.34l1.96-8.01h-12.36l2.04-8.41c.08-.25.2-.48.43-.63.18-.15.38-.23.55-.23h14l-4.18,17.25-2.37,9.62h8.26L149.6,0h-25.33Z"
            />
            <path
              fill="#2d2a32"
              d="M156.85,26.86c-.33,0-.58-.13-.81-.38-.2-.23-.28-.53-.23-.86l6.14-25.63h-2.44c-1.79,0-3.37.53-4.78,1.59-1.38,1.03-2.32,2.44-2.74,4.18l-4.83,20.14c-.55,2.34-.05,4.43,1.49,6.22,1.51,1.81,3.52,2.72,5.99,2.72h20.72c.05-.28.2-.83.38-1.64.2-.81.43-1.71.65-2.69.23-.98.45-1.86.63-2.62.1-.43.2-.76.25-1.01l-20.42-.03Z"
            />
          </g>

          <g>
            <path
              fill="#e12428"
              d="M2.21,1.37h6.21c.63,0,1.09.59.93,1.2l-1.3,5.02c-.11.42-.49.72-.93.72H.96C.34,8.31-.12,7.73.03,7.12L1.28,2.1c.11-.43.49-.73.93-.73Z"
            />
            <path
              fill="#e12428"
              d="M8.54,7.7h6.21c.63,0,1.09.59.93,1.2l-1.3,5.02c-.11.42-.49.72-.93.72h-6.16c-.62,0-1.08-.59-.93-1.19l1.25-5.02c.11-.43.49-.73.93-.73Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
